import { render, staticRenderFns } from "./DecoratorDetails.vue?vue&type=template&id=1071ea75&scoped=true&"
import script from "./DecoratorDetails.vue?vue&type=script&lang=js&"
export * from "./DecoratorDetails.vue?vue&type=script&lang=js&"
import style0 from "./DecoratorDetails.vue?vue&type=style&index=0&id=1071ea75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071ea75",
  null
  
)

export default component.exports